import { QueuedIntakeFileInfo } from '../../../../../../store/uploadStore';
import { FileWithPath } from 'react-dropzone';

const sanitizeS3Key = (key: string): string => {
  const illegalChars = /[^a-zA-Z0-9!\-_.*'()]/g;
  return key.replace(illegalChars, '_');
};

const isImageType = (type?: string) => type?.startsWith('image/') || false;

const generateUploadPath = (file: FileWithPath, currentBatch: number) => {
  const relativePath = file.relativePath?.replace(/^\.[\\/]/, '');

  const deepestFolder = relativePath
    ? (() => {
        const parts = relativePath.split('/');
        return parts.length > 1 ? parts[parts.length - 2] : undefined;
      })()
    : undefined;

  const prefix = sanitizeS3Key(deepestFolder ?? String(currentBatch));
  const name = sanitizeS3Key(file.name);
  return `${prefix}/${name}`;
};

export const generateQueuedIntakeFileInfoState = (
  files: FileWithPath[],
  currentBatch: number,
): QueuedIntakeFileInfo[] => {
  return files.map((file) => {
    const name = generateUploadPath(file, currentBatch);
    const fileCategory = isImageType(file.type) ? 'image' : 'non-image';

    return {
      name,
      uploaded: false,
      coords: undefined,
      validation: undefined,
      takenAt: undefined,
      cameraModel: undefined,
      droneModel: undefined,
      size: file.size!,
      fileCategory,
      file,
      uploadedSize: 0,
      isBeingValidated: false,
      isBeingUploaded: false,
    };
  });
};
